import * as React from "react";

export const Filter2Icon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.79296 3.05741C1.16267 2.35298 0.847532 2.00076 0.835649 1.70142C0.825324 1.44139 0.937066 1.19146 1.13774 1.02576C1.36875 0.835022 1.84137 0.835022 2.78662 0.835022H15.1557C16.101 0.835022 16.5736 0.835022 16.8046 1.02576C17.0053 1.19146 17.117 1.44139 17.1067 1.70142C17.0948 2.00076 16.7796 2.35298 16.1494 3.05741L11.3942 8.37202C11.2685 8.51244 11.2057 8.58269 11.161 8.66261C11.1212 8.73344 11.092 8.80977 11.0744 8.88902C11.0545 8.97844 11.0545 9.07269 11.0545 9.26111V13.717C11.0545 13.8799 11.0545 13.9614 11.0282 14.0319C11.005 14.0942 10.9672 14.1499 10.918 14.1946C10.8624 14.2452 10.7867 14.2754 10.6355 14.336L7.80213 15.4694C7.4958 15.5919 7.34263 15.6531 7.21973 15.6275C7.11222 15.6052 7.01788 15.5414 6.95722 15.4498C6.88784 15.3452 6.88784 15.1802 6.88784 14.8504V9.26111C6.88784 9.07269 6.88784 8.97844 6.86794 8.88902C6.85029 8.80977 6.82114 8.73344 6.78142 8.66261C6.73662 8.58269 6.6738 8.51244 6.54816 8.37202L1.79296 3.05741Z"
      stroke="#667085"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
